export const CompanyInitializer = async (companyStore, assessmentsStore, usersStore, modulesStore, companyId = undefined) => {
    if (!companyId) {
        return;
    }

    await companyStore.loadCompany(companyId);

    // Persist the now-active company. This is the single chokepoint every
    // "make this company active" flow passes through (login default, Add
    // Business Line, and the post-switch reload), so writing here guarantees
    // sessionStorage always reflects the current company. Without this, only
    // the dropdown switcher wrote the key, and any later re-init (remount,
    // re-auth bounce, second tab) silently fell back to companyIds[0] and
    // bounced multi-company users to their first company.
    try {
        sessionStorage.setItem('selectedCompanyId', companyId);
    } catch (_) {
        /* storage disabled (e.g. Safari private mode) — best-effort only */
    }

    const loaders = [
        assessmentsStore.loadCompanyAssessments(companyId),
        modulesStore.load(companyId),
    ];

    if (usersStore.currentUser.userType !== 'Sales Member') {
        loaders.push(usersStore.loadCompanyUsers(companyId));
    }

    await Promise.all(loaders);
};